const errorCodesMapping = {
    '-32603': 'Could not replace existing transaction',
    INSUFFICIENT_FUNDS: 'Insufficient funds for this transaction.',
};
const errorReasonsMapping = {
    'provided ENS name resolves to null': 'Invalid address. Please check that the entered address is correct.',
};
const transactionErrorMessage = (error) => {
    const { code } = error;
    const defaultMessage = 'Something went wrong.';
    if (!code)
        return defaultMessage;
    return (errorCodesMapping[code] ||
        (error.reason && errorReasonsMapping[error.reason]) ||
        defaultMessage);
};

export { transactionErrorMessage };
